export default "__VITE_ASSET__uQJwyvZN__"